import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NotesService, Note } from '../Services/note.service';
 
import { ActivatedRoute } from '@angular/router'; 

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css']
})
export class NotesComponent implements OnInit {
  notes: Note[] = [];
  newNote: Note = { id: 0, projectId: 0, date: new Date(), author: '', content: '' };
  editingNote: Note | null = null;
  projectId: number = 0;

  constructor(
    private notesService: NotesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.projectId = +id; // Convert string to number
        this.newNote.projectId = this.projectId; // Set projectId for new notes
        this.loadNotes();
      }
    });
  }

  loadNotes(): void {
    this.notesService.getNotes(this.projectId).subscribe({
      next: (notes) => this.notes = notes,
      error: (err) => console.error('Failed to load notes', err)
    });
  }

  addNote(form: NgForm): void {
    if (form.valid && this.newNote.author && this.newNote.content) {
      this.newNote.projectId = this.projectId; // Ensure projectId is set
      this.notesService.createNote(this.newNote).subscribe({
        next: (note) => {
          this.notes.push(note);
          this.resetForm();
          form.resetForm();
        },
        error: (err) => console.error('Failed to create note', err)
      });
    }
  }

  editNote(note: Note): void {
    this.editingNote = { ...note };
    this.newNote = { ...note };
  }

  updateNote(form: NgForm): void {
    if (this.editingNote && form.valid && this.newNote.author && this.newNote.content) {
      this.newNote.projectId = this.projectId; // Ensure projectId is set
      this.notesService.updateNote(this.editingNote.id, this.newNote).subscribe({
        next: () => {
          const index = this.notes.findIndex(note => note.id === this.editingNote!.id);
          if (index !== -1) {
            this.notes[index] = { ...this.newNote, id: this.editingNote!.id, date: new Date() };
            this.resetForm();
            form.resetForm();
          }
        },
        error: (err) => console.error('Failed to update note', err)
      });
    }
  }

  deleteNote(id: number): void {
    this.notesService.deleteNote(id).subscribe({
      next: () => {
        this.notes = this.notes.filter(note => note.id !== id);
      },
      error: (err) => console.error('Failed to delete note', err)
    });
  }

  resetForm(): void {
    this.newNote = { id: 0, projectId: this.projectId, date: new Date(), author: '', content: '' };
    this.editingNote = null;
  }
}